// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"8fc091c4","796":"9767271a"}[chunkId] + ".chunk.js";
};